import types from "./types";

const defaultValues = {
  data: {},
  fetching: false,
  fetched: false,
  error: null,
  appliedBenchmark: '',
};

export default function reducer(state = defaultValues, action) {
  switch (action.type) {
    case types.FETCH_BENCHMARKS_START: {
      return {
        ...state,
        fetching: true,
        fetched: false,
      };
    }
    case types.FETCH_BENCHMARKS: {
      return {
        ...state,
        data: action.payload,
        fetching: false,
        fetched: true,
      };
    }
    case types.FETCH_BENCHMARKS_ERROR: {
      return {
        ...state,
        fetching: false,
        fetched: false,
        error: action.payload.response,
      };
    }
    case types.CLEAR: {
      return { ...defaultValues };
    }
    case types.APPLY_BENCHMARK: {
      return {
        ...state,
        appliedBenchmark: action.payload,
      };
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/redux/benchmarks/reducers.js